module Meevo.Plugins.ActivityLog {

    import DiscountLine = Meevo.Model.DiscountLine;
    import SalePayment = Meevo.Model.SalePayment;
    import SaleStateEnum = Meevo.Model.SaleStateEnum;
    import DiscountTypeEnum = Meevo.Model.DiscountTypeEnum;
    import NounEnum = Meevo.Model.NounEnum

    export interface IExportDataService {
        getAuditList: (auditDetails: any) => any;
        getWorkSheet: (activityType: CategorySearchEnum, auditDetails: any) => any;
    }

    declare let XLSX: any;

    export class ExportDataService implements IExportDataService {
        private lineShift: number = 0;

        private dateFilter;

        static $inject = [
            '$translate',
            '$filter',
            'meevo.plugins.activityLog.ActivityLogService'
        ];

        constructor(
            protected $translate: angular.translate.ITranslateService,
            protected $filter: angular.IFilterService,
            protected activityLogService: IActivityLogService
        ) {
            this.dateFilter = this.$filter('meevoDateTimeFilter');
        }

        getAuditList(auditDetails) {
            let workSheet = {};
            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 0 })] = { v: this.$translate.instant('LABEL_USER_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 0 })] = { v: this.$translate.instant('LABEL_DESCRIPTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 0 })] = { v: this.$translate.instant('LABEL_APPLICATION'), t: 's' };

            for (let i = 0; i < auditDetails.length; i++) {
                workSheet[XLSX.utils.encode_cell({
                    c: 0,
                    r: i + 1
                })] = { v: this.dateFilter(auditDetails[i].dateTime), t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 1, r: i + 1 })] = { v: auditDetails[i].userId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 2, r: i + 1 })] = { v: auditDetails[i].description, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: i + 1 })] = { v: auditDetails[i].application, t: 's' };
            }

            workSheet['!ref'] = XLSX.utils.encode_range({
                s: { c: 0, r: 0 },
                e: { c: 11, r: auditDetails.length + 1 }
            });

            return workSheet;
        }

        getWorkSheet(activityType: CategorySearchEnum, details) {
            let workSheet = {};
            switch (activityType) {
                case CategorySearchEnum.Appointment:
                    workSheet = this.prepareAppointmentWorksheet(details);
                    break;
                case CategorySearchEnum.Clients:
                    workSheet = this.prepareClientWorksheet(details);
                    break;
                case CategorySearchEnum.Transaction:
                    workSheet = this.prepareTransactionWorksheet(details);
                    break;
                case CategorySearchEnum.DataChanges:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_DATA_CHANGES') }));
                    break;
                case CategorySearchEnum.SecurityAudit:
                    workSheet = this.prepareSecurityAuditWorksheet(details);
                    break;
                case CategorySearchEnum.Payroll:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_PAYROL') }));
                    break;
                case CategorySearchEnum.PayrollData:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_PAYROL_DATA') }));
                    break;
                case CategorySearchEnum.PayrollSettings:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_PAYROL_SETTINGS') }));
                    break;
                case CategorySearchEnum.AllPayroll:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_ALL_PAYROLL') }));
                    break;
                case CategorySearchEnum.ReportScheduler:
                    workSheet = this.prepareDataChangesWorksheet(details, this.$translate.instant('MESSAGE_ACTIVITYLOG_EXPORT', { type: this.$translate.instant('LABEL_REPORT_SCHEDULER') }));
                    break;
                default:
                    break;
            }

            if (details.saleLines) {
                workSheet['!ref'] = XLSX.utils.encode_range({
                    s: { c: 0, r: 0 },
                    e: { c: 14, r: details.saleLines.length + this.lineShift + 2 }
                });

                this.lineShift = 0;
            }
            if (details.changeItems) {
                workSheet['!ref'] = XLSX.utils.encode_range({
                    s: { c: 0, r: 0 },
                    e: { c: 11, r: details.changeItems.length + 2 }
                });
            }

            return workSheet;
        }

        private prepareAppointmentWorksheet(auditDetails) {
            let workSheet = {};

            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: 'APPOINTMENT CHANGES EXPORT', t: 's' };

            workSheet[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 1 })] = { v: this.$translate.instant('LABEL_LOGIN_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 1 })] = { v: this.$translate.instant('LABEL_ACTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 1 })] = { v: this.$translate.instant('LABEL_APPLICATION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 4, r: 1 })] = { v: this.$translate.instant('HEADER_FEATURE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 5, r: 1 })] = { v: this.$translate.instant('LABEL_USER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 6, r: 1 })] = { v: this.$translate.instant('LABEL_OS_DEVICE_TYPE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 7, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 8, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER_VERSION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 9, r: 1 })] = { v: this.$translate.instant('LABEL_RESOLUTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 10, r: 1 })] = { v: this.$translate.instant('LABEL_FIELD'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 12, r: 1 })] = { v: this.$translate.instant('LABEL_OLD_VALUE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 11, r: 1 })] = { v: this.$translate.instant('LABEL_NEW_VALUE'), t: 's' };

            for (let i = 0; i < auditDetails.changeItems.length; i++) {
                workSheet[XLSX.utils.encode_cell({
                    c: 0,
                    r: i + 2
                })] = { v: this.dateFilter(auditDetails.dateTime), t: 's' };//
                workSheet[XLSX.utils.encode_cell({ c: 1, r: i + 2 })] = { v: auditDetails.employeeCode ? auditDetails.loginId + ': ' + auditDetails.employeeCode : auditDetails.loginId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 2, r: i + 2 })] = { v: auditDetails.action, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: i + 2 })] = { v: auditDetails.application, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 4, r: i + 2 })] = { v: auditDetails.appArea, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 5, r: i + 2 })] = { v: auditDetails.clientName, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 6, r: i + 2 })] = { v: auditDetails.session.os, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 7, r: i + 2 })] = { v: auditDetails.session.browser, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 8, r: i + 2 })] = { v: auditDetails.session.browserVersion, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 9, r: i + 2 })] = {
                    v: auditDetails.session.resolution,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 10, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].fieldName,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 11, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].newValue,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 12, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].oldValue,
                    t: 's'
                };
            }

            return workSheet;
        }

        private prepareClientWorksheet(auditDetails) {
            let workSheet = {};

            let arrayClients = auditDetails.changeItems.filter((item) => {
                return item.fieldName != 'CustomAudit'
            });

            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: 'CLIENT CHANGES EXPORT', t: 's' };

            workSheet[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 1 })] = { v: this.$translate.instant('LABEL_LOGIN_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 1 })] = { v: this.$translate.instant('LABEL_ACTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 1 })] = { v: this.$translate.instant('LABEL_APPLICATION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 4, r: 1 })] = { v: this.$translate.instant('HEADER_FEATURE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 5, r: 1 })] = { v: this.$translate.instant('LABEL_USER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 6, r: 1 })] = { v: this.$translate.instant('LABEL_OS_DEVICE_TYPE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 7, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 8, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER_VERSION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 9, r: 1 })] = { v: this.$translate.instant('LABEL_RESOLUTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 10, r: 1 })] = { v: this.$translate.instant('LABEL_FIELD'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 12, r: 1 })] = { v: this.$translate.instant('LABEL_OLD_VALUE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 11, r: 1 })] = { v: this.$translate.instant('LABEL_NEW_VALUE'), t: 's' };
            for (let i = 0; i < arrayClients.length; i++) {
                workSheet[XLSX.utils.encode_cell({
                    c: 0,
                    r: i + 2
                })] = { v: this.dateFilter(auditDetails.dateTime), t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 1, r: i + 2 })] = { v: auditDetails.employeeCode ? auditDetails.loginId + ': ' + auditDetails.employeeCode : auditDetails.loginId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 2, r: i + 2 })] = { v: auditDetails.action, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: i + 2 })] = { v: auditDetails.application, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 4, r: i + 2 })] = { v: auditDetails.appArea, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 5, r: i + 2 })] = { v: auditDetails.clientName, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 6, r: i + 2 })] = { v: auditDetails.session.os, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 7, r: i + 2 })] = { v: auditDetails.session.browser, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 8, r: i + 2 })] = { v: auditDetails.session.browserVersion, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 9, r: i + 2 })] = {
                    v: auditDetails.session.resolution,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 10, r: i + 2 })] = { v: arrayClients[i].fieldFullName ? arrayClients[i].fieldFullName : arrayClients[i].fieldName, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 12, r: i + 2 })] = { v: arrayClients[i].oldValue, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 11, r: i + 2 })] = { v: arrayClients[i].newValue, t: 's' };
            }

            return workSheet;
        }

        private prepareDataChangesWorksheet(auditDetails, header: string): {} {
            let workSheet = {};
            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: header.toUpperCase(), t: 's' };

            workSheet[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 1 })] = { v: this.$translate.instant('LABEL_LOGIN_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 1 })] = { v: this.$translate.instant('LABEL_DISPLAY_NAME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 1 })] = { v: this.$translate.instant('HEADER_FEATURE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 4, r: 1 })] = { v: this.$translate.instant('LABEL_SCREEN'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 5, r: 1 })] = { v: this.$translate.instant('LABEL_OS_DEVICE_TYPE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 6, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 7, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER_VERSION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 8, r: 1 })] = { v: this.$translate.instant('LABEL_RESOLUTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 9, r: 1 })] = { v: this.$translate.instant('LABEL_FIELD'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 11, r: 1 })] = { v: this.$translate.instant('LABEL_OLD_VALUE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 10, r: 1 })] = { v: this.$translate.instant('LABEL_NEW_VALUE'), t: 's' };

            for (let i = 0; i < auditDetails.changeItems.length; i++) {
                workSheet[XLSX.utils.encode_cell({
                    c: 0,
                    r: i + 2
                })] = { v: this.dateFilter(auditDetails.dateTime), t: 's' };//
                workSheet[XLSX.utils.encode_cell({ c: 1, r: i + 2 })] = { v: auditDetails.employeeCode ? auditDetails.loginId + ': ' + auditDetails.employeeCode : auditDetails.loginId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 2, r: i + 2 })] = { v: auditDetails.client.displayName, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: i + 2 })] = { v: auditDetails.appArea, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 4, r: i + 2 })] = { v: auditDetails.application, t: 's' };

                workSheet[XLSX.utils.encode_cell({ c: 5, r: i + 2 })] = { v: auditDetails.session.os, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 6, r: i + 2 })] = { v: auditDetails.session.browser, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 7, r: i + 2 })] = { v: auditDetails.session.browserVersion, t: 's' };

                workSheet[XLSX.utils.encode_cell({ c: 8, r: i + 2 })] = {
                    v: auditDetails.session.resolution,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 9, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].fieldName,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 11, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].oldValue,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 10, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].newValue,
                    t: 's'
                };
            }

            return workSheet;
        }

        private prepareTransactionWorksheet(transactionInfo) {
            let workSheet = {};
            let count: number = 0;
            if (transactionInfo.hasSplitCommission) count++;
            if (transactionInfo.hasStudentTeacherModuleTurnOn) count++;

            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: 'TRANSACTIONS EXPORT', t: 's' };

            workSheet[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 1 })] = { v: this.$translate.instant('LABEL_LOGIN_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 1 })] = { v: this.$translate.instant('LABEL_TRANSACTION_STATUS'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 1 })] = { v: this.$translate.instant('LABEL_TRANSACTION_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 4, r: 1 })] = { v: this.$translate.instant('CUSTOM_LABEL_EMPLOYEE'), t: 's' };


            if (transactionInfo.hasSplitCommission) {
                workSheet[XLSX.utils.encode_cell({ c: 5, r: 1 })] = { v: this.$translate.instant('LABEL_COMMISSION'), t: 's' };
            }
            if (transactionInfo.hasStudentTeacherModuleTurnOn) {
                workSheet[XLSX.utils.encode_cell({ c: count + 4, r: 1 })] = { v: this.$translate.instant('LABEL_OVERSEEN_BY'), t: 's' };
            }

            workSheet[XLSX.utils.encode_cell({ c: count + 5, r: 1 })] = { v: this.$translate.instant('LABEL_ITEM'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 6, r: 1 })] = { v: this.$translate.instant('LABEL_ITEM_PRICE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 7, r: 1 })] = { v: this.$translate.instant('LABEL_PAYMENT_METHOD'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 8, r: 1 })] = { v: this.$translate.instant('LABEL_DISCOUNT_TYPE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 9, r: 1 })] = { v: this.$translate.instant('LABEL_TOTAL_AMOUNT_PAID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 10, r: 1 })] = { v: this.$translate.instant('LABEL_TOTAL_AMOUNT_DISCOUNTED'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: count + 11, r: 1 })] = { v: this.$translate.instant('LABEL_TOTAL_AMOUNT_REFUNDED'), t: 's' };
            if (transactionInfo.refundNoteText && transactionInfo.isHasRefund) {
                workSheet[XLSX.utils.encode_cell({ c: count + 12, r: 1 })] = { v: this.$translate.instant('LABEL_REFUND_REASON'), t: 's' };
            }

            for (let i = 0; i < transactionInfo.saleLines.length; i++) {
                let employeeFullName = transactionInfo.saleLines[i].employee.lastName + ', ' + transactionInfo.saleLines[i].employee.firstName;

                workSheet[XLSX.utils.encode_cell({ c: 0, r: this.lineShift + i + 2 })] = { v: this.dateFilter(transactionInfo.transactionDateTime), t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 1, r: this.lineShift + i + 2 })] = { v: transactionInfo.generalizedData.userId, t: 's' };                
                workSheet[XLSX.utils.encode_cell({ c: 2, r: this.lineShift + i + 2 })] = { v: transactionInfo.saleLines[i].isRefund ? this.$translate.instant('LABEL_REFUND') : SaleStateEnum[transactionInfo.saleState], t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: this.lineShift + i + 2 })] = { v: transactionInfo.transactionId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 4, r: this.lineShift + i + 2 })] = { v: transactionInfo.saleLines[i].employee.displayName || employeeFullName, t: 's' };

                if (this.activityLogService.hasSplitCommission(transactionInfo.saleLines[i])) {
                    workSheet[XLSX.utils.encode_cell({ c: 5, r: this.lineShift + i + 2 })] = { v: `${(transactionInfo.saleLines[i].employeeSplitCommission * 100).toFixed(0)}%`, t: 's' };
                    // Second employee
                    workSheet[XLSX.utils.encode_cell({ c: 4, r: this.lineShift + i + 3 })] = { v: transactionInfo.saleLines[i].secondEmployee.displayName, t: 's' };
                    workSheet[XLSX.utils.encode_cell({ c: 5, r: this.lineShift + i + 3 })] = { v: `${(transactionInfo.saleLines[i].secondEmployeeSplitCommission * 100).toFixed(0)}%`, t: 's' };
                }

                if (transactionInfo.hasStudentTeacherModuleTurnOn) {
                    workSheet[XLSX.utils.encode_cell({ c: count + 4, r: this.lineShift + i + 2 })] = { v: transactionInfo.saleLines[i].teacher ? transactionInfo.saleLines[i].teacher.displayName : 'NA', t: 's' };
                }

                workSheet[XLSX.utils.encode_cell({ c: count + 5, r: this.lineShift + i + 2 })] = { v: transactionInfo.saleLines[i].item.shortcut ? transactionInfo.saleLines[i].item.shortcut + ': ' + transactionInfo.saleLines[i].item.displayName : transactionInfo.saleLines[i].item.displayName, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: count + 6, r: this.lineShift + i + 2 })] = { v: transactionInfo.saleLines[i].basePrice, t: 's' };

                if (transactionInfo.paymentLines.length > 0) {
                    const paymentList = transactionInfo.uniquePayments.map((payment: SalePayment) => payment.paymentTypeDisplayName).join(', ');
                    workSheet[XLSX.utils.encode_cell({ c: count + 7, r: this.lineShift + i + 2 })] = { v: paymentList, t: 's' };
                } else {
                    workSheet[XLSX.utils.encode_cell({ c: count + 7, r: this.lineShift + i + 2 })] = { v: 'NA', t: 's' };
                }

                if (transactionInfo.saleLines[i].discountLines.length > 0) {
                    const discountsList = transactionInfo.saleLines[i].discountLines.map((discount: DiscountLine) => DiscountTypeEnum[discount.type]).join(', ');
                    workSheet[XLSX.utils.encode_cell({ c: count + 8, r: this.lineShift + i + 2 })] = { v: discountsList, t: 's' };
                } else {
                    workSheet[XLSX.utils.encode_cell({ c: count + 8, r: this.lineShift + i + 2 })] = { v: 'NA', t: 's' };
                }

                workSheet[XLSX.utils.encode_cell({ c: count + 9, r: this.lineShift + i + 2 })] = { v: transactionInfo.totalPayments, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: count + 10, r: this.lineShift + i + 2 })] = { v: transactionInfo.totalDiscounts, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: count + 11, r: this.lineShift + i + 2 })] = { v: transactionInfo.isHasRefund ? transactionInfo.totalRefunded : transactionInfo.totalAmountRedeemed, t: 's' };

                if (transactionInfo.refundNoteText && transactionInfo.saleLines[i].isRefund) {
                    workSheet[XLSX.utils.encode_cell({ c: count + 12, r: this.lineShift + i + 2 })] = { v: transactionInfo.refundNoteText, t: 's' };
                }

                // shift number of lines if there is a split commision
                if (this.activityLogService.hasSplitCommission(transactionInfo.saleLines[i])) this.lineShift++;
            }

            return workSheet;
        }

        private prepareSecurityAuditWorksheet(auditDetails) {
            let workSheet = {};
            let columnTitle: string;

            switch (auditDetails.nounId) {
                case NounEnum.SecurityElevation:
                case NounEnum.SecurityRoleManager:
                    columnTitle = 'HEADER_FEATURE';
                    break;
                case NounEnum.EmployeeUserSecurity:
                    columnTitle = 'LABEL_FIELD';
                    break;
            }

            //c - column, r - row, v - value, t - type
            workSheet[XLSX.utils.encode_cell({ c: 0, r: 0 })] = { v: 'SECURITY AUDIT EXPORT', t: 's' };

            workSheet[XLSX.utils.encode_cell({ c: 0, r: 1 })] = { v: this.$translate.instant('LABEL_DAY_DATE_TIME'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 1, r: 1 })] = { v: this.$translate.instant('LABEL_LOGIN_ID'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 2, r: 1 })] = { v: this.$translate.instant('LABEL_ACTION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 3, r: 1 })] = { v: this.$translate.instant(columnTitle), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 5, r: 1 })] = { v: this.$translate.instant('LABEL_OLD_VALUE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 4, r: 1 })] = { v: this.$translate.instant('LABEL_NEW_VALUE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 6, r: 1 })] = { v: this.$translate.instant('LABEL_OS_DEVICE_TYPE'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 7, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 8, r: 1 })] = { v: this.$translate.instant('LABEL_BROWSER_VERSION'), t: 's' };
            workSheet[XLSX.utils.encode_cell({ c: 9, r: 1 })] = { v: this.$translate.instant('LABEL_RESOLUTION'), t: 's' };

            if (auditDetails.nounId === NounEnum.SecurityRoleManager) {
                workSheet[XLSX.utils.encode_cell({ c: 10, r: 1 })] = { v: this.$translate.instant('LABEL_SESSION_ID'), t: 's' };
            }
            //if (this.params.areaSecurityAudit !== SecurityAuditCriteriaEnum.SecurityRoleSettingsUsers) {
            //    workSheet[XLSX.utils.encode_cell({
            //        c: 9,
            //        r: 1
            //    })] = { v: this.$translate.instant('LABEL_LOGGED_IN_USER_SECURITY_ROLES'), t: 's' };
            //}

            for (let i = 0; i < auditDetails.changeItems.length; i++) {
                workSheet[XLSX.utils.encode_cell({
                    c: 0,
                    r: i + 2
                })] = { v: this.dateFilter(auditDetails.dateTime), t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 1, r: i + 2 })] = { v: auditDetails.employeeCode ? auditDetails.loginId + ': ' + auditDetails.employeeCode : auditDetails.loginId, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 2, r: i + 2 })] = { v: auditDetails.action, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 3, r: i + 2 })] = { v: auditDetails.appArea, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 5, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].oldValue,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 4, r: i + 2 })] = {
                    v: auditDetails.changeItems[i].newValue,
                    t: 's'
                };
                workSheet[XLSX.utils.encode_cell({ c: 6, r: i + 2 })] = { v: auditDetails.session.os, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 7, r: i + 2 })] = { v: auditDetails.session.browser, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 8, r: i + 2 })] = { v: auditDetails.session.browserVersion, t: 's' };
                workSheet[XLSX.utils.encode_cell({ c: 9, r: i + 2 })] = {
                    v: auditDetails.session.resolution,
                    t: 's'
                };

                if (auditDetails.nounId === NounEnum.SecurityRoleManager) {
                    workSheet[XLSX.utils.encode_cell({ c: 10, r: i + 2 })] = {
                        v: auditDetails.internalSessionId,
                        t: 's'
                    };
                }
                //if (this.params.areaSecurityAudit !== SecurityAuditCriteriaEnum.SecurityRoleSettingsUsers) {
                //    workSheet[XLSX.utils.encode_cell({ c: 9, r: i + 2 })] = { v: this.oneItem.roleName, t: 's' };
                //}
            }

            return workSheet;
        }
    }

    angular.module('meevo.plugins.activityLog')
        .service('meevo.plugins.activityLog.ExportDataService', ExportDataService);
}